import request from '@/utils/request'

// getSupplier
export function getSupplier(param) {
  let data = param
  return request({
    url: `/inspection/v80a1040/getSupplier`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getV80ShipNo
export function getV80ShipNo(param) {
  let data = param
  return request({
    url: `/inspection/v80a1040/getV80ShipNo`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// v80a1040List
export function v80a1040List(param) {
  let data = param
  return request({
    url: `/inspection/v80a1040/v80a1040List`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getRespMaker
export function getRespMaker(param) {
  let data = param
  return request({
    url: `/inspection/v80a1040/getRespMaker`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// v80InspTime
export function v80InspTime(param) {
  let data = param
  return request({
    url: `/inspection/v80a1040/v80InspTime`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getLqcMember
export function getLqcMember(param) {
  let data = param
  return request({
    url: `/inspection/v80a1040/getLqcMember`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// v80a1040Update
export function v80a1040Update(param) {
  let data = param
  return request({
    url: `/inspection/v80a1040/v80a1040Update`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// v80a1040Delete
export function v80a1040Delete(param) {
  let data = param
  return request({
    url: `/inspection/v80a1040/v80a1040Delete`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}